import React from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";

interface AttachmentIconProps {
  attachmentType?: string;
  attachmentName?: string;
}

export const AttachmentIcon = ({ attachmentType, attachmentName }: AttachmentIconProps): React.ReactElement => {
  if (!attachmentType && !attachmentName) {
    return <AttachFileIcon sx={{ fontSize: 18, color: "text.secondary" }} />;
  }
  
  const type = attachmentType?.toLowerCase() || "";
  const name = attachmentName?.toLowerCase() || "";
  
  // Check MIME type first
  if (type.includes("pdf") || name.endsWith(".pdf")) {
    return <PictureAsPdfIcon sx={{ fontSize: 18, color: "error.main" }} />;
  }
  if (type.includes("image") || name.match(/\.(png|jpg|jpeg|gif|webp)$/)) {
    return <ImageIcon sx={{ fontSize: 18, color: "primary.main" }} />;
  }
  
  // Default to generic attachment icon
  return <AttachFileIcon sx={{ fontSize: 18, color: "text.secondary" }} />;
};
